import React from 'react';
// import { Link } from "react-router-dom";
import { withRouter } from 'react-router';
import './style.module.scss';

// Pages that render their own full-bleed shell (AuthShell) and must not be boxed in by
// `.wrapper-page` or get a second Duet logo on top of the one in their own header.
const SELF_LAID_OUT_PAGES = ['/auth/login', '/auth/forgotpassword'];

class AuthLayout extends React.PureComponent {
  render() {
    const { children, location } = this.props;
    const pathname = (location?.pathname || '').toLowerCase();
    const ownsLayout = SELF_LAID_OUT_PAGES.some((page) => pathname.startsWith(page));

    return (
      <div className={ownsLayout ? undefined : 'wrapper-page'}>
        {!ownsLayout && (
          <div className="text-center">
            <a href="https://www.duetinc.com" className="logo-lg" target="_new">
              <img
                src={`${process.env.PUBLIC_URL}/resources/images/logo.png`}
                style={{ width: '45%', marginBottom: '75px' }}
                alt=""
              />
            </a>
          </div>
        )}
        {children}
      </div>
    );
  }
}

export default withRouter(AuthLayout);
